export function pluralize(
  w: string,
  length: number | undefined,
  returnNumber: boolean = true
) {
  if (!w || length === undefined) return '';

  if (!returnNumber && length <= 1) return `${w}`;

  if (!returnNumber && length > 1) return `${w}s`;

  if (length === 1) return `${length} ${w}`;

  return `${length} ${w}s`;
}
